const MARKETPLACE_TRANSPORT_TYPE = {
	tartuTruck: 'TARTU_TRUCK',
	raplaTruck: 'RAPLA_TRUCK',
	cargobus: 'CARGOBUS',
	warehouse: 'WAREHOUSE',
	memboCourier: 'MEMBO_COURIER',
	producer: 'PRODUCER',
};

export default MARKETPLACE_TRANSPORT_TYPE;